<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const router = useRouter();

const campaignTypes = computed(() => [
  {
    key: 'utility',
    icon: 'i-lucide-receipt-text',
    tone: 'text-n-teal-11 bg-n-teal-3',
    title: t('CAMPAIGN.WHATSAPP.TYPE_SELECTION.UTILITY.TITLE'),
    description: t('CAMPAIGN.WHATSAPP.TYPE_SELECTION.UTILITY.DESCRIPTION'),
  },
  {
    key: 'marketing',
    icon: 'i-lucide-megaphone',
    tone: 'text-n-amber-11 bg-n-amber-3',
    title: t('CAMPAIGN.WHATSAPP.TYPE_SELECTION.MARKETING.TITLE'),
    description: t('CAMPAIGN.WHATSAPP.TYPE_SELECTION.MARKETING.DESCRIPTION'),
  },
]);

const selectType = campaignType => {
  router.push({
    name: 'campaigns_whatsapp_category_index',
    params: { campaignCategory: campaignType.key },
  });
};

const goBack = () => {
  router.push({ name: 'campaigns_index' });
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="sticky top-0 z-10 px-6 bg-n-surface-1">
      <div class="w-full max-w-5xl mx-auto">
        <div class="flex items-center justify-between w-full h-20 gap-4">
          <div class="flex items-center gap-3 min-w-0">
            <Button
              icon="i-lucide-arrow-left"
              size="sm"
              variant="ghost"
              color-scheme="secondary"
              @click="goBack"
            />
            <div class="min-w-0">
              <h1 class="text-heading-1 text-n-slate-12">
                {{ t('CAMPAIGN.WHATSAPP.TYPE_SELECTION.TITLE') }}
              </h1>
              <p class="mt-1 text-sm text-n-slate-11">
                {{ t('CAMPAIGN.WHATSAPP.TYPE_SELECTION.SUBTITLE') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>

    <main class="flex-1 px-6 overflow-y-auto">
      <div class="w-full max-w-5xl mx-auto py-6">
        <div class="divide-y divide-n-weak border-t border-n-weak">
          <button
            v-for="campaignType in campaignTypes"
            :key="campaignType.key"
            type="button"
            class="w-full flex items-start justify-between gap-4 px-4 py-5 -mx-4 text-left rounded-lg hover:bg-n-alpha-1 transition-colors"
            @click="selectType(campaignType)"
          >
            <div class="flex items-start gap-4 min-w-0">
              <span
                class="grid place-items-center size-10 rounded-lg flex-shrink-0"
                :class="campaignType.tone"
              >
                <span class="size-5" :class="[campaignType.icon]" />
              </span>
              <span class="min-w-0">
                <span class="block text-base font-semibold text-n-slate-12">
                  {{ campaignType.title }}
                </span>
                <span class="block mt-1 text-sm text-n-slate-11">
                  {{ campaignType.description }}
                </span>
              </span>
            </div>
            <span class="i-lucide-chevron-right size-4 text-n-slate-8 mt-3" />
          </button>
        </div>
      </div>
    </main>
  </section>
</template>
